import { Link } from 'react-router-dom';
import TownShip from './assets/township tours.jpg';

function TownshipTourPage() {
  return (
    <div className="tour-detail-page">
      <section className="hero-subpage township-tour-hero">
        <div className="hero-content">
          <h1>Ebamba's Authentic Cape Town Township Tour</h1>
          <p>Gain unique insights into South Africa's history and vibrant contemporary culture.</p>
        </div>
      </section>

      <section className="section-spacing light-bg">
        <div className="container">
          <h2 className="text-center">A Journey of Understanding and Connection</h2>
          <div className="content-intro">
            <img src={TownShip} alt="Township Tour" className="tour-main-image" />
            <p>Ebamba Travel & Tours invites you on a profound and respectful Township Tour, an essential experience for understanding South Africa's past and present. Our tours aim to educate and inspire, taking you beyond the conventional tourist routes to explore vibrant communities, meet local residents, and witness the resilience and spirit that define these areas.</p>
            <p>Led by experienced local guides, you'll visit historical sites, learn about the legacy of apartheid, and engage with the lively culture of townships like Langa or Khayelitsha. This isn't just a tour; it's an opportunity for genuine connection and a deeper appreciation of Cape Town's diverse population.</p>
          </div>

          <h3 className="text-center mt-5">What to Expect on Your Township Tour</h3>
          <div className="expect-grid">
            <div className="expect-item">
              <i className="fas fa-people-arrows"></i>
              <h4>Community Engagement</h4>
              <p>Interact with local entrepreneurs, artists, and community leaders, gaining firsthand perspectives.</p>
            </div>
            <div className="expect-item">
              <i className="fas fa-history"></i>
              <h4>Historical Insights</h4>
              <p>Visit significant landmarks, including museums and memorials, that tell the story of apartheid and the struggle for freedom.</p>
            </div>
            <div className="expect-item">
              <i className="fas fa-music"></i>
              <h4>Vibrant Culture</h4>
              <p>Experience the lively atmosphere through local music, art, and perhaps even a traditional meal or drink (optional).</p>
            </div>
            <div className="expect-item">
              <i className="fas fa-hands-helping"></i>
              <h4>Responsible Tourism</h4>
              <p>Your visit supports local businesses and community initiatives, contributing directly to the local economy.</p>
            </div>
          </div>

          <h3 className="text-center mt-5">Hear From Our Enlightened Travelers</h3>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <p>"Our Township Tour was incredibly moving and informative. Our guide was exceptional, sharing personal stories that truly brought the history to life. An essential part of our Cape Town journey with Ebamba."</p>
              <span>– Robert S. from USA</span>
            </div>
            <div className="testimonial-card">
              <p>"This tour offers such a vital perspective. It was humbling and inspiring to witness the spirit of the communities. Thank you, Ebamba, for facilitating such a meaningful experience."</p>
              <span>– Anya K. from Poland</span>
            </div>
          </div>

          <div className="text-center mt-5">
            <Link to="/contact" className="btn btn-primary large-btn tour-btn">Book Your Township Tour</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default TownshipTourPage;
